import { useEffect, useRef } from 'react';

import { useAccountState } from '@/contexts/account/account-context';

import { setDashboardStoreAccountId } from '../stores/use-unified-dashboard-store';

export function useDashboardAccountSync(): void {
  const previousAccountId = useRef<string | null>(null);
  const { currentAccount } = useAccountState();
  const accountId = currentAccount?.id ?? null;

  useEffect(() => {
    if (previousAccountId.current === accountId) {
      return;
    }

    previousAccountId.current = accountId;
    setDashboardStoreAccountId(accountId);
  }, [accountId]);
}
